import { createContext } from 'react';
import { TOAST_TYPE } from '../interfaces.js';

const RootContext = /*#__PURE__*/createContext({
  bodyState: {
    metamaskQrCode: {
      show: false,
      wallet: null
    },
    installLinks: {
      show: false,
      wallet: null
    },
    multiChainSelector: {
      show: false,
      wallet: null
    }
  },
  toast: {
    message: "",
    type: TOAST_TYPE.SUCCESS
  },
  setBodyState: () => {},
  setToast: () => {}
});

export { RootContext };
